import * as PIXI from "pixi.js-legacy";
import * as spine from "pixi-spine";

import jquery from 'jquery';
global.$ = jquery;

import * as TWEEN from "@tweenjs/tween.js";
global.TWEEN = TWEEN;

import * as P3 from "p3";
P3.utils.TWEEN = TWEEN;

import Main from './Main';

startApp();

function startApp() {
    const main = new Main(1024, 768);
    main.init();
}